import React, { Component } from "react";
import {
  Wrapper,
  Row,
  Copy,
  Bold,
  Icon,
  Button
} from "app/NativeComponents/common";
import { openUrl } from "app/NativeActions";
class EnginePlanFeature extends Component {
  renderCheck(feature) {
    if (!!feature.fields.check) {
      return (
        <Icon
          icon={"check"}
          size={18}
          color={this.props.colors.success_color}
          style={{ marginRight: 5 }}
        />
      );
    }
  }
  renderHelperText(feature) {
    if (!!feature.fields.helperText && !!feature.fields.helperTextLink) {
      return (
        <Button
          className={"pricing-helper-text"}
          onPress={() => openUrl(feature.fields.helperTextLink)}
        >
          <Copy style={{ fontSize: 10, color: this.props.colors.active_color }}>
            {feature.fields.helperText}
          </Copy>
        </Button>
      );
    }
  }

  renderExtraText(feature) {
    if (!!feature.fields.extraText) {
      return (
        <Copy
          style={{
            fontSize: 10,
            color: this.props.colors.light_text_color,
            marginLeft: 10
          }}
        >
          {feature.fields.extraText}
        </Copy>
      );
    }
  }

  render() {
    const { feature } = this.props;
    if (feature && feature.fields) {
      return (
        <Wrapper style={{ padding: 10, paddingBottom: 0 }}>
          <Wrapper>
            <Wrapper>
              <Copy style={{ fontSize: 14 }}>
                <Bold>
                  {!!feature.fields.boldTitle
                    ? feature.fields.boldTitle + " "
                    : ""}
                </Bold>
                {!!feature.fields.boldTitle
                  ? feature.fields.subTitle
                  : feature.fields.title}
              </Copy>
            </Wrapper>
            {this.renderHelperText(feature)}
          </Wrapper>
          {this.renderExtraText(feature)}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default EnginePlanFeature;
